export const PUBLIC_CONSENT_VERSION = "2026-04-24";

export function normalizePublicConsentVersion(value: string | null | undefined): string {
  const trimmed = value?.trim();
  return trimmed || PUBLIC_CONSENT_VERSION;
}
